<template>
  <div>
    <div class="mt-5">
      <div class="relative">
        <h2 class="pr-10 text-lg font-bold">
          {{ busstop.name }}
        </h2>
      </div>
    </div>
    <div class="my-2">
      <!--
      {{ busstop.description }}
      <progressive-img
        v-if="busstop.imgUrl"
        :src="busstop.imgUrl"
        class="w-full mt-2"
      />
      -->
      <h3 class="section-title my-2">{{$t('tour_port')}}</h3>
      <ul class="place-info">
        <!--
        <li class="flex">
          <dd class="w-2/4 text-supplement">サービス提供期間：</dd>
          <dt>{{ serviceArea.serviceStartAt }}〜{{ serviceArea.serviceEndAt }}</dt>
        </li>
        -->
        <li>
          <dd class="w-2/4 text-supplement">{{$t('tour_business_start')}}</dd>
          <dt>{{ serviceArea.startTime }}</dt>
        </li>
        <li>
          <dd class="w-2/4 text-supplement">{{$t('tour_business_end')}}</dd>
          <dt>{{ serviceArea.endTime }}</dt>
        </li>
        <li>
          <dd class="w-2/4 text-supplement">{{$t('tour_max_passenger')}}</dd>
          <dt>{{ capacity }}</dt>
        </li>
      </ul>
      <div class="text-right mt-4">
        <a :href="serviceArea.faqUrl" class="text-link flex justify-end items-center" target="_blank">
          {{$t('tour_faq_info_label')}}
          <svg xmlns="http://www.w3.org/2000/svg" width="9.815" height="9.815" viewBox="0 0 9.815 9.815" class="ml-1">
            <path id="Rectangle" d="M6.634.5,6.94,6.488a.421.421,0,0,1-.451.451L.5,6.634a.539.539,0,0,1-.5-.5A.43.43,0,0,1,.123,5.8L5.8.123a.478.478,0,0,1,.673.034A.529.529,0,0,1,6.634.5Z" transform="translate(0 4.907) rotate(-45)" fill="#1998c8"/>
          </svg>
        </a>
      </div>
      <div class="mt-4"><a @click="$store.dispatch('reservation/start', busstop)" class="button-primary block" :class="{ disabled: !busstop.enableBoarding }"><span>{{$t('tour_reserve_label')}}</span></a></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      busstop: 'drawer/getTarget',
    }),
    serviceArea: function () {
      const serviceAreaId = this.$route.query.serviceAreaId
      return this.$store.getters['serviceAreas/get'](serviceAreaId)
    },
    capacity: function () {
      return  this.serviceArea && this.serviceArea.additional && this.serviceArea.additional.capacity
    }
  }
}
</script>
